import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-571adf0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quiz-container" }
const _hoisted_2 = { class: "quiz-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizForm = _resolveComponent("QuizForm")!
  const _component_QuizTest = _resolveComponent("QuizTest")!
  const _component_QuizResults = _resolveComponent("QuizResults")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.activeView === 'homepage')
        ? (_openBlock(), _createBlock(_component_QuizForm, {
            key: 0,
            onOnSubmit: _ctx.setFormValues
          }, null, 8, ["onOnSubmit"]))
        : (_ctx.activeView === 'quiz')
          ? (_openBlock(), _createBlock(_component_QuizTest, {
              key: 1,
              quizId: _ctx.formValues.quizId,
              onOnSubmitAnswerHandler: _ctx.saveQuestionAnswer,
              onOnLastQuestion: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToView('results')))
            }, null, 8, ["quizId", "onOnSubmitAnswerHandler"]))
          : (_openBlock(), _createBlock(_component_QuizResults, {
              key: 2,
              formValues: _ctx.formValues,
              answers: _ctx.questionAnswers,
              onOnClick: _ctx.retakeQuiz
            }, null, 8, ["formValues", "answers", "onOnClick"]))
    ])
  ]))
}